export function calculateNextRoundGoal(count: number): number {
	let divideCounter = 0;
	let tempCount = count;
	while (tempCount >= 10) {
		tempCount /= 10;
		divideCounter += 1;
	}
	return (Math.floor(tempCount) + 1) * 10 ** divideCounter;
}
